<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Admission</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <!-- <li routerLinkActive="active">
                        <a routerLink="/admission/message" > Principal's Message to Parents</a>
                    </li> -->
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/process" >Admission Procedure</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/subjects" >Subjects offered in Class XI</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/entrance-syllabus" >Entrance Test Syllabus</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/admission/library" > Library and eBooks</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/hours" >School Hours</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/houses" >School Houses</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/uniform" >School Uniform</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/fee" >Fee Structure</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/admission/entrance-result" >Entrance Test Result</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>